import styled from '@emotion/styled';
import React from 'react';
import { GRAY, WHITE } from '../../../styles/constants/color';
import { HEADER_INDEX } from '../../../styles/constants/priority';
import { HEADER_HEIGHT } from '../../../styles/constants/size';
import SolecarLogo from '../icon/SolecarLogo';
import LogoutButton from './LogoutButton';
import Navigation from './navigation/Navigation';
import { useState } from 'react';
import Background from '../Background';
import useSwitching from '../../../hooks/common/useSwitching';
import DynamicMenuButton from '../button/DynamicMenuButton';

const Base = styled.header`
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  position: fixed;
  grid-template-columns: 1fr 180px 25px;
  width: 100%;
  height: ${HEADER_HEIGHT};
  background-color: ${WHITE};
  z-index: ${HEADER_INDEX};
  padding: 0 20px;
  border-bottom: 1px solid ${GRAY};

  @media (max-width: 405px) {
    grid-template-columns: 1fr 110px 25px;
  }
`;

/**
 *  공통 header 컴포넌트
 *  */
function Header(): JSX.Element {
  const [navActive, switchingNav]: [boolean, () => void] = useSwitching();
  return (
    <>
      <Base>
        <SolecarLogo
          onClick={() => {
            navActive ? switchingNav() : undefined;
          }}
        />
        <LogoutButton />
        <DynamicMenuButton active={navActive} onClick={switchingNav} />
        {/* {navActive ? (
          <CloseButton onClick={() => switchingNav()} />
        ) : (
          <HamburgerButton onClick={() => switchingNav()} />
        )} */}
      </Base>
      <Navigation active={navActive} closeEvent={() => switchingNav()} />
      {navActive && <Background zIndex={HEADER_INDEX - 1} />}
    </>
  );
}

export default Header;
